export class TenantSettingModel {
    id: number;
    dateFormat: string;
    logoPath: string;
    tenantBusinessName: string;
    taxRate: number;
    isUseQuickBook: boolean;
    quickBookExpiredTime: string;
    subdomain: string;
    metaData: { [name: string]: { value: number, display: string, valueString: string }[] };

    constructor(data?) {
        if (data) {
            this.id = data.id;
            this.dateFormat = data.dateFormat;
            this.logoPath = data.logo;
            this.taxRate = data.taxRate;
            this.tenantBusinessName = data.tenantBusinessName;
            this.isUseQuickBook = data.isUseQuickBook;
            this.quickBookExpiredTime = data.quickBookExpiredTime;
            this.tenantBusinessName = data.tenantBusinessName;
            this.subdomain = data.subdomain;
            this.metaData = data.metaData;
        }
    }
}
